module.exports = __webpack_public_path__ + "img/exp_new.afefdc25.png";